import { render, staticRenderFns } from "./CredentialsDrugTest.vue?vue&type=template&id=7a0fa3ea&scoped=true&"
import script from "./CredentialsDrugTest.vue?vue&type=script&lang=js&"
export * from "./CredentialsDrugTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0fa3ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRadio,VRadioGroup,VTooltip})
